export default "__VITE_ASSET__DizQfv0F__"